/*
 * Merklogo's: stilstaan, en om de zoveel seconden één merk opschuiven.
 *
 * Verving de doorlopende marquee. Een logo dat altijd beweegt leest lastiger
 * dan een logo dat stilstaat, en het trok de aandacht weg van de producten
 * erboven.
 *
 * Waarom verschuiven en niet scrollen: de rij liet zich niet scrollen. Er stond
 * overflow-x op auto en de inhoud was breder dan het vlak, maar scrollLeft bleef
 * op nul staan -- ook bij directe toewijzing, en ook zonder scroll-snap. Een
 * los testelement op dezelfde pagina scrolde wel, dus het lag aan deze opbouw.
 * Verschuiven met transform doet hier hetzelfde werk en is beter te
 * voorspellen.
 *
 * Drie dingen die het rustig houden:
 *
 * - Alleen bewegen als de rij in beeld is. Een rij die onderaan de pagina staat
 *   en al vijf keer is opgeschoven voordat je hem ziet, mist zijn doel.
 * - Stilstaan zolang de muis erop staat.
 * - Niets doen als het systeem om minder beweging vraagt.
 */

(() => {
  const minderBeweging = window.matchMedia('(prefers-reduced-motion: reduce)');

  const inBeeld = (el) => {
    const r = el.getBoundingClientRect();
    if (r.height === 0) return false;
    const zichtbaar = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
    return zichtbaar / r.height > 0.3;
  };

  const koppel = (rij) => {
    if (rij.dataset.merkenrij === '1') return;
    rij.dataset.merkenrij = '1';

    const seconden = parseFloat(rij.dataset.collettStap) || 7;
    const vlak = rij.parentElement;
    let index = 0;
    let stilstaan = false;

    rij.addEventListener('pointerenter', () => (stilstaan = true));
    rij.addEventListener('pointerleave', () => (stilstaan = false));

    const stapBreedte = () => {
      const kinderen = [...rij.children];
      if (kinderen.length < 2) return 0;
      return Math.round(
        kinderen[1].getBoundingClientRect().left - kinderen[0].getBoundingClientRect().left
      );
    };

    const stap = () => {
      if (stilstaan || minderBeweging.matches || !inBeeld(rij)) return;

      const breedte = stapBreedte();
      if (!breedte) return;

      // Hoeveel merken passen er niet meer in het vlak? Verder dan dat
      // opschuiven laat een lege rechterkant zien.
      const teveel = Math.max(0, rij.scrollWidth - vlak.clientWidth);
      const maxStappen = Math.ceil(teveel / breedte);

      index = maxStappen === 0 ? 0 : (index + 1) % (maxStappen + 1);
      rij.style.transform = `translateX(${-index * breedte}px)`;
    };

    setInterval(stap, seconden * 1000);
  };

  const init = () => document.querySelectorAll('[data-collett-stap]').forEach(koppel);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
